import clsx from 'clsx'
import Image from 'next/image'

interface Props {
  isActive: boolean
  toggleState: () => void
  className?: string
}

const CollapseArrow = ({isActive, className, toggleState}: Props) => {
  function onToggleState() {
    if (!isActive) {
      setTimeout(() => window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'}), 10)
      toggleState()
    } else {
      toggleState()
      // window.scrollTo({top: 50, behavior: 'smooth'})
      // setTimeout(() => {
      //   toggleState()
      // }, 350)
    }
  }

  return (
    <div className={clsx(className)}>
      <button className='p-5' aria-label='expand' onClick={onToggleState}>
        <Image
          src='https://static.gamezop.com/comet/assets/img2/gray-arrow-down.svg'
          alt='footer arrow'
          height={6}
          width={10}
          className={clsx({'rotate-180': !isActive, 'mr-20': isActive})}
        />
      </button>
    </div>
  )
}

export default CollapseArrow
